<div class="card">
  <div class="card-header">
    <h3 class="text-brand mb-3">
      {{ rendering() | scFieldValue: 'TitleText' }}
    </h3>
    <p
      class="mb-0"
      wlAutomationId="homebattery-advice--battery-capacity-advice-description"
    >
      {{ descriptionText().value }}
    </p>
  </div>
  @let energyCapacityValue = energyCapacity();
  @if (
    energyCapacityValue &&
    energyCapacityValue <= 15 &&
    energyCapacityValue !== 0
  ) {
    <div class="card-body">
      <wl-homebattery-usage-capacity-breakdown
        [fields]="rendering().fields"
        [energyCapacity]="energyCapacityValue"
        wlAutomationId="homebattery-advice--usage-capacity-breakdown"
      />
    </div>
  }
</div>
